<template>
  <span>
    <el-dialog title="作品运行记录" :visible="visible" width="760px" @close="$emit('update:visible',false)">
      <el-table v-loading="loading" :data="runs" empty-text="暂无运行记录">
        <el-table-column prop="id" label="任务编号"/>
        <el-table-column prop="trigger_type" label="触发方式"/>
        <el-table-column prop="status" label="状态"/>
        <el-table-column prop="total_count" label="总数"/>
        <el-table-column prop="succeeded_count" label="成功"/>
        <el-table-column prop="failed_count" label="失败"/>
        <el-table-column label="日志"><template slot-scope="s"><el-button type="text" :loading="loadingRunId===s.row.id" @click="logs(s.row)">{{loadingRunId===s.row.id?'加载中':'查看'}}</el-button></template></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="运行日志" :visible.sync="logVisible" width="860px">
      <el-table v-loading="logLoading" :data="items" empty-text="该任务暂无日志">
        <el-table-column prop="created_at" label="时间"/>
        <el-table-column prop="source_id" label="作品"/>
        <el-table-column prop="action" label="动作"/>
        <el-table-column prop="status" label="状态"/>
        <el-table-column prop="detail_text" label="详情" min-width="260" show-overflow-tooltip/>
      </el-table>
    </el-dialog>
  </span>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'

export default {
  props: ['visible'],
  data () { return { runs: [], items: [], loading: false, logLoading: false, loadingRunId: '', logVisible: false } },
  watch: { visible (value) { if (value) this.load() } },
  methods: {
    async load () {
      if (this.loading) return
      this.loading = true
      try {
        this.runs = (await yuqingApi.get('creator-content/runs?limit=20')).runs || []
      } catch (error) {
        this.runs = []
        this.$message.error(error.message || '运行记录加载失败')
      } finally {
        this.loading = false
      }
    },
    async logs (run) {
      if (!run || this.loadingRunId) return
      this.loadingRunId = run.id
      this.logLoading = true
      this.logVisible = true
      this.items = []
      try {
        this.items = (await yuqingApi.get(`creator-content/runs/${encodeURIComponent(run.id)}/logs?limit=200`)).logs || []
      } catch (error) {
        this.$message.error(error.message || '运行日志加载失败')
      } finally {
        this.loadingRunId = ''
        this.logLoading = false
      }
    }
  }
}
</script>
